/**
 * renamePasskey management call (Req 11.4)
 *
 * `PATCH /auth/passkey/credentials/:credentialId` を `{ label }` body で発行し、更新後の
 * `PasskeySummary` (design.md §API Contract 912 行 `200 PasskeySummary`) を返す。
 * `@auth/client` ApiClient の公開 seam は `get` / `post` のみ (`@auth/client` 改修禁止
 * Req 11.6/11.7) のため、`apiClient.post(path, body, { method: 'PATCH' })` の method override
 * seam で PATCH を発行する (内部 `request` が `options.method` を verb より後に spread する)。
 * ApiClient が HTTP error を `AuthError` として surface するため、ここでは再ラップしない。
 */
/**
 * 指定 credential の label を更新し、更新後サマリを返す。
 *
 * @param apiClient `@auth/client` の ApiClient (inject 経由)
 * @param credentialId 更新対象の base64url credential ID
 * @param label 新しい label
 */
export async function renamePasskey(apiClient, credentialId, label) {
    const path = `/auth/passkey/credentials/${encodeURIComponent(credentialId)}`;
    // ApiClient の method override seam (verb を PATCH に差替え)。body は { label }。
    return apiClient.post(path, { label }, { method: "PATCH" });
}
//# sourceMappingURL=rename-passkey.js.map